import {
  PrimaryButton,
  Separator,
  SpinButton,
  Spinner,
  SpinnerSize,
  Stack,
  Text,
  TextField,
} from "@fluentui/react";
import NumberField, { parseInputNumber } from "../NumberField";
import { useCallback, useEffect, useState } from "react";
import { CIRO_URL, ReportStatus, KDV } from "./conf";

interface RevenueDayProps {
  day: number;
  month: number;
}

export function RevenueDay(props: RevenueDayProps) {
  const [status, setStatus] = useState<ReportStatus>(ReportStatus.Loading);
  const [quantity, setQuantity] = useState(1);
  const [inputValue, setInputValue] = useState(0);
  const updateServerData = useCallback(() => {
    fetch(
      `${CIRO_URL}/get?month=${props.month}&day=${props.day}&year=2026&frequency=Daily`
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.ok !== true) {
          setStatus(ReportStatus.Error);
          console.error("Error fetching data:");
          console.error(data);
          return;
        }
        if (data.reported) {
          setQuantity(data.data.quantity);
          setInputValue(data.data.value / KDV);
          setStatus(ReportStatus.Reported);
        } else {
          setStatus(ReportStatus.Pending);
        }
      })
      .catch((error) => {
        console.error(error);
        setStatus(ReportStatus.Error);
      });
  }, [props.day, props.month]);
  useEffect(() => {
    updateServerData();
  }, [props.day, props.month]);
  return (
    <div>
      <Stack horizontal tokens={{ childrenGap: 15 }} style={{ justifyContent: "center" }}>
        <Text variant="large" style={{ width: "80px", textAlign: "right" }}>
          {props.day}.{props.month}.2026
        </Text>
        <div style={{ width: "80px" }}>
          <SpinButton
            disabled={status !== ReportStatus.Pending}
            value={quantity.toString()}
            onChange={(_, value) =>
              setQuantity(Math.min(99, Math.max(0, parseInt(value ?? "1"))))
            }
          />
        </div>
        <NumberField
          disabled={status !== ReportStatus.Pending}
          value={inputValue.toFixed()}
          onChange={(_, value) =>
            setInputValue(Math.min(1e6, Math.max(0, parseInputNumber(value) ?? 0)))
          }
        />
        <PrimaryButton
          text="Kaydet"
          disabled={status !== ReportStatus.Pending}
          onClick={() => {
            setStatus(ReportStatus.Loading);
            fetch(`${CIRO_URL}/report`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                month: props.month.toString(),
                day: props.day.toString(),
                year: "2026",
                value: inputValue * KDV,
                quantity,
                apiKey: "1bff00512579",
                frequency: "Daily",
                KDV,
              }),
            })
              .then(() => updateServerData())
              .catch((error) => {
                console.error(error);
                setStatus(ReportStatus.Error);
              });
          }}
        />
        <Text variant="large" style={{ width: "200px", textAlign: "center" }}>
          KDV'siz: {(inputValue * KDV).toFixed(2)}
        </Text>
        <Text
          variant="large"
          style={{ width: "80px", textAlign: "center", color: STATUS_COLORS[status] }}
        >
          {STATUS_NAMES[status]}
        </Text>
      </Stack>
      <Separator />
    </div>
  );
}

const STATUS_COLORS: Record<ReportStatus, string> = {
  [ReportStatus.Loading]: "orange",
  [ReportStatus.Pending]: "",
  [ReportStatus.Reported]: "green",
  [ReportStatus.Error]: "red",
};
const STATUS_NAMES: Record<ReportStatus, string | JSX.Element> = {
  [ReportStatus.Loading]: <Spinner size={SpinnerSize.large} />,
  [ReportStatus.Pending]: "Bekliyor",
  [ReportStatus.Reported]: "Raporlandı",
  [ReportStatus.Error]: "Hata!",
};
